module.exports = __webpack_public_path__ + "static/img/plan2.e7a47ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/training-plan/plan2.png
// module id = WaZD
// module chunks = 35